import React from 'react';
import BlueprintToggle from './BlueprintToggle';
import { useBlueprint } from '../../contexts/BlueprintContext';
import { hasBlueprintSession } from '../../services/blueprintsApi';

/**
 * GlobalBlueprintToggle — the ONE mount of the Rule Book / Blueprint book icon.
 *
 * 2026-06-22 (FIX 10 part A3) — the icon used to be pasted into 17 page headers
 * (18 render sites; DrawingRoom had two), which is why it reached 17 of ~109
 * pages. App.js imported the toggle and never rendered it globally. Same shape
 * as the Google OAuth start, the blueprints fetch, the avatar rule and the scope
 * list: one behaviour, many copies, most of them missing.
 *
 * scripts/check-blueprint-toggle-single-source.js fails the build if any other
 * file renders its own copy.
 */
export const GlobalBlueprintToggle = ({ darkMode = false }) => {
  const { isOpen } = useBlueprint();

  // Nothing to open before sign-in — the blueprints it reads are tenant-scoped.
  if (!hasBlueprintSession()) return null;

  return (
    <div
      className="fixed right-5 bottom-[calc(76px+env(safe-area-inset-bottom,0px))] z-[95] print:hidden"
      data-testid="global-blueprint-toggle"
    >
      <div
        className={`rounded-full shadow-lg border backdrop-blur-sm transition-colors ${
          darkMode
            ? 'bg-[#0D0D0D]/90 border-[#2A2A2A]'
            : 'bg-white/90 border-stone-200'
        } ${isOpen ? 'ring-1 ring-[#70170F]/40' : ''}`}
      >
        <BlueprintToggle darkMode={darkMode} className="h-10 w-10" />
      </div>
    </div>
  );
};

export default GlobalBlueprintToggle;
